var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-center"},[_vm._v(" Offline... ")]),_c('br'),_c('div',{staticClass:"wobble"},[_c('Favicon',{attrs:{"size":"100"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }